import {Card} from "./Card.model";

export const StageContent: Card[] = [
    {
        title: 'A Room in the Castle',
        text: [
            'Written by Lauren Gunderson',
            'MOXIE Theatre',
            'Directed by Kim Strassburger'
        ],
        image: '/resource/a-room-in-the-castle/image_00013.jpg',
        imageAttribution: '',
        path: 'stage/a-room-in-the-castle',
        resource: 'a-room-in-the-castle'
    },
    {
        title: 'Refuse It',
        text: [
            'Written by Phanesia Pharel',
            'Wagner New Play Festival 2025',
            'Directed by Delicia Turner-Sonnenberg'
        ],
        image: '/resource/refuse-it/image_00014.jpg',
        imageAttribution: '',
        path: 'stage/refuse-it',
        resource: 'refuse-it'
    },
    {
        title: 'Dido and Aeneas',
        text: [
            'Written by Henry Purcell',
            'UCSD Dept. of Music',
            'Directed by Miguel Zazueta- Cervera'
        ],
        image: '/resource/dido-aeneas/image_00012.jpeg',
        imageAttribution: '',
        path: 'stage/dido-aeneas',
        resource: 'dido-aeneas'
    },
    {
        title: 'All Wounds Bleed / The Medium',
        text: [
            'Written by Christopher Cerrone / Peter Maxwell Davies',
            'UCSD Dept. of Music - kallisti 2025',
            'Directed by Susan Narucki'
        ],
        image: '/resource/all-wounds-medium/image_00006.jpg',
        imageAttribution: '',
        path: 'stage/all-wounds-medium',
        resource: 'all-wounds-medium'
    },
    {
        title: 'Goldilocks Screentime',
        text: [
            'Written by Lula Britos & Claire McNerney',
            'La Jolla Playhouse - WOW Festival 2025',
            'Directed by Lula Britos & Claire McNerney'
        ],
        image: '/resource/goldilocks/image_00002.jpg',
        imageAttribution: '',
        path: 'stage/goldilocks',
        resource: 'goldilocks'
    },
    {
        title: 'The Rogues Trial',
        text: [
            'Written by Ariano Suassuna',
            'University of California San Diego 2025',
            'Directed by Ludmila de Brito'
        ],
        image: '/resource/rogues-trial/image_00011.jpg',
        imageAttribution: '',
        path: 'stage/rogues-trial',
        resource: 'rogues-trial'
    },
    {
        title: 'Hedda Gabler',
        text: [
            'Written by Henrik Ibsen',
            'University of California San Diego 2024',
            'Directed by Lisa Portes'
        ],
        image: '/resource/hedda-gabler/image_00001.jpg',
        imageAttribution: 'Tzu Yu Su',
        path: 'stage/hedda-gabler',
        resource: 'hedda-gabler'
    },
    {
        title: 'Dead Girls Quinceañera',
        text: [
            'Written by Phanesia Pharel',
            'Wagner New Play Festival 2024',
            'Directed by Lamar Perry'
        ],
        image: '/resource/dgq/image_00006.png',
        imageAttribution: '',
        path: 'stage/dgq',
        resource: 'dgq'
    },
    {
        title: 'WinterWorks 24',
        text: [
            '"Open Your Eyes"',
            'WinterWorks 2024',
            'Choreography by Kara Mack'
        ],
        image: '/resource/winter-works/image_00005.jpeg',
        imageAttribution: 'Doug McMinimy',
        path: 'stage/winter-works',
        resource: 'winter-works'
    },
    {
        title: 'The Promise',
        text: [
            'Written by Jose Rivera',
            'University of California San Diego 2023',
            'Directed by Ludmila de Brito'
        ],
        image: '/resource/the-promise/image_00001.jpeg',
        imageAttribution: 'Rich Soublet',
        path: 'stage/the-promise',
        resource: 'the-promise'
    },
    {
        title: 'नेहा & Neel',
        text: [
            'Written by Ankita Raturi',
            'Wagner New Play Festival 2023',
            'Directed by Rosie Glen-Lambert'
        ],
        image: '/resource/neha-and-neel/image_00009.jpg',
        imageAttribution: 'Rich Soublet',
        path: 'stage/neha-and-neel',
        resource: 'neha-and-neel'
    }
];
